/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Overwrite_TextInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to overwrite this project?" |
*
* @param {Explorer_Display_Overwrite_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_text = /** @type {((inputs?: Explorer_Display_Overwrite_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etes-vous sur de vouloir ecraser ce projet ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Möchten Sie dieses Projekt wirklich überschreiben?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sei sicuro di voler sovrascrivere questo progetto?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы уверены, что хотите перезаписать этот проект?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Estás seguro de que deseas sobrescribir este proyecto?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您确定要覆盖此项目吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このプロジェクトを上書きしてもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई इस प्रोजेक्ट को ओवरराइट करना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tem certeza de que deseja sobrescrever este projeto?")
	return /** @type {LocalizedString} */ ("Are you sure you want to overwrite this project?")
});